module.exports = __webpack_public_path__ + "a216230391abb491420139400706dd6b.svg";